import {FC} from 'react';
import {Link as RouterLink} from 'react-router-dom';
import {Link, Tooltip} from '@mui/material';

// UUIDs are too long for the table, so only the head and the tail are shown
const shortenId = (id: string) =>
  id.length > 18 ? `${id.slice(0, 6)}-${id.slice(-12)}` : id;

interface Props {
  id: string;
  to: string;
}

export const ShortIdLink: FC<Props> = ({id, to}) => (
  <Tooltip title={id}>
    <Link component={RouterLink} to={to} underline="hover">
      {shortenId(id)}
    </Link>
  </Tooltip>
);
